import customAxios from "./axiosConfig";

const DiscountService = {
    list: function() {
        var api_url = window.Urls["discount_list"]();
        return customAxios.get(api_url);
    }
}

export default DiscountService;